import ProfileMenu from "@/components/app/Navigation/GlobalHeader/ProfileMenu";
import NotificationMenu from "@/components/app/Navigation/GlobalHeader/Notifications";
import SettingsMenu from "@/components/app/Navigation/GlobalHeader/SettingsMenu";
import { Box, Stack } from "@mui/material";
import { Navbar } from "@trimble/modus-cmx";
import { generatePath, useNavigate } from "react-router";
import { ROUTE_PARAMS } from "@/constants";
import { useAccount } from "@/context/account";
import { FeatureFlaggedComponent } from "@/context/FeatureFlags";
import { useMe } from "@/context/me";
import { UiFeatureFlagNames } from "@/gql/graphql";
import { isDealerWithoutRole } from "@/permissions";
import { GlobalSearch } from "@/components/Navigation/GlobalHeader/GlobalSearch/GlobalSearch";
import QuickAccess from "@/components/app/Navigation/GlobalHeader/QuickAccess";
import RecentlyViewed from "@/components/app/Navigation/GlobalHeader/RecentlyViewed";

function GlobalHeader() {
  const navigate = useNavigate();
  const { accountRouteId } = useAccount();
  const { me } = useMe();
  const dealerWithoutRole = isDealerWithoutRole(me.role, me.permissionList);

  const handleTrimbleLogoClick = () => {
    if (!accountRouteId) return;
    navigate(
      generatePath(`/:${ROUTE_PARAMS.ACCOUNT_ID}`, {
        accountId: accountRouteId,
      })
    );
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Navbar
        logoName="subscriptions"
        centered
        visibility={{}} // Keeps default user button disabled as we use our own
        onTrimbleLogoClick={handleTrimbleLogoClick}
      >
        <Stack slot="end" direction="row" alignItems="center" spacing={1}>
          {!dealerWithoutRole && (
            <>
              <GlobalSearch />
              <QuickAccess />
              <FeatureFlaggedComponent
                flagName={UiFeatureFlagNames.RecentlyViewed}
              >
                <RecentlyViewed />
              </FeatureFlaggedComponent>
              <SettingsMenu />
              <NotificationMenu />
            </>
          )}
          <ProfileMenu />
        </Stack>
      </Navbar>
    </Box>
  );
}

export default GlobalHeader;
